export type RovoNavigationClickedProps = {
	source: string;
	queryHash: string;
	queryLength: number;
	searchSessionId?: string;
	isHello?: boolean;
	referrer?: string;
	experiment?: string;
	commonAttributes?: Record<string, any>;
};

export const onRovoNavigationClicked = ({
	source,
	experiment,
	commonAttributes,
	queryHash,
	queryLength,
	searchSessionId,
	isHello,
	referrer,
}: RovoNavigationClickedProps) => ({
	source,
	eventType: 'ui' as const,
	action: 'clicked',
	actionSubject: 'rovoNavigation',
	name: 'rovoNavigation',
	attributes: {
		commonAttributes,
		queryHash,
		queryLength,
		searchSessionId,
		isHello,
		referrer,
		additionalAttributes: {
			experiment,
		},
	},
});
